import { remember, serializeDataToCacheKey } from '@tuic/cache';
import { logger } from '@tuic/logger';

import { Pcl } from '../../index';
import { CacheTag } from '../../utils';

import type { Locale } from '@tuic/i18n';

/**
 * Fetches the events of given tripCode.
 */
export const getTripEvents = async (
  tripCode: string,
  locale: Locale,
): Promise<Pcl.Event[]> => {
  const { data, error } = await Pcl.getTripsByTripCodeEvents({
    path: { tripCode },
    query: { locale },
  });

  if (error) {
    logger.error(
      `Could not fetch trip events. Trip: ${tripCode}, Locale: ${locale}`,
    );
    logger.error(error);

    return [];
  }

  return data ?? [];
};

/**
 * Fetches the events of given tripCode.
 */
export const cachedGetTripEvents = (
  tripCode: string,
  locale: Locale,
): Promise<Pcl.Event[]> =>
  remember(
    serializeDataToCacheKey([CacheTag.pcl, 'getTripEvents', locale, tripCode]),
    () => getTripEvents(tripCode, locale),
    {
      tags: [CacheTag.pcl, CacheTag.tripResource, CacheTag.getTripEvents],
      ttl: 600,
    },
  );
